// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "Configurator" + "." + "b3f3d82df8c2f79b" + ".css"
}